// import React from "react";

// function ResultPill({ h }) {
//   if (!h.resolved) {
//     const t =
//       h.batchDrawAt?.toDate?.() ||
//       (h.batchDrawAt ? new Date(h.batchDrawAt) : null);
//     return (
//       <span className="text-yellow-400 font-bold">
//         {t ? `Pending (draw @ ${t.toLocaleTimeString()})` : "Pending"}
//       </span>
//     );
//   }
//   if (h.won)
//     return <span className="text-green-400 font-bold">WON ${h.amount}</span>;
//   return <span className="text-gray-400">Lost</span>;
// }

// export default function UserHistory({ history }) {
//   if (!history?.length)
//     return (
//       <div className="bg-slate-800 rounded-xl p-4">
//         <div className="text-gray-400 text-center">No lottery history yet.</div>
//       </div>
//     );
//   return (
//     <div className="bg-slate-800 rounded-xl p-4">
//       <div className="font-bold mb-2">My Lottery History</div>
//       <ul className="space-y-1">
//         {history.map((h, i) => (
//           <li key={i} className="flex justify-between text-sm">
//             <span>
//               Card #{h.cardId} — {h.numbers.join(", ")}
//               {typeof h.winningNumber === "number" && (
//                 <span className="ml-2 text-xs text-gray-400">
//                   win#: {h.winningNumber}
//                 </span>
//               )}
//             </span>
//             <ResultPill h={h} />
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }
import React from "react";

function NumberChips({ h }) {
  const nums = (h.numbers || []).map(Number);

  // styles
  const base =
    "inline-flex items-center justify-center rounded-full px-2 py-0.5 text-xs font-semibold";
  const gap = "mr-1 mb-1"; // spacing between chips

  // pending look
  if (!h.resolved) {
    return (
      <div className="flex flex-wrap max-w-[520px]">
        {nums.map((n) => (
          <span
            key={n}
            className={`${base} ${gap} bg-amber-400/10 text-amber-300 ring-1 ring-amber-400/40 animate-pulse`}
          >
            {n}
          </span>
        ))}
      </div>
    );
  }

  // resolved (won/lost)
  const win = typeof h.winningNumber === "number" ? h.winningNumber : null;
  return (
    <div className="flex flex-wrap max-w-[520px]">
      {nums.map((n) => {
        const isWin = win !== null && n === win && h.won;
        const cls = isWin
          ? "bg-green-500/15 text-green-300 ring-1 ring-green-400/50 shadow-[0_0_8px_rgba(34,197,94,.4)]"
          : "bg-slate-700 text-slate-300";
        return (
          <span key={n} className={`${base} ${gap} ${cls}`}>
            {n}
          </span>
        );
      })}
    </div>
  );
}

function ResultPill({ h }) {
  if (!h.resolved) {
    const t =
      h.batchDrawAt?.toDate?.() ||
      (h.batchDrawAt ? new Date(h.batchDrawAt) : null);
    return (
      <span
        className="inline-flex flex-col items-end px-3 py-2 rounded-2xl bg-amber-400/10
                       text-amber-200 font-semibold ring-1 ring-amber-400/30"
      >
        <span className="flex items-center gap-1">🕒 Pending</span>
        {t && (
          <span className="text-amber-300/90 text-xs">
            draw @ {t.toLocaleTimeString()}
          </span>
        )}
      </span>
    );
  }
  if (h.won)
    return (
      <span
        className="inline-flex items-center gap-1 px-3 py-1.5 rounded-2xl
                       bg-green-500/10 text-green-400 font-bold ring-1 ring-green-400/40"
      >
        ✅ WON ${h.amount}
      </span>
    );
  return (
    <span
      className="inline-flex items-center gap-1 px-3 py-1.5 rounded-2xl
                     bg-slate-700 text-slate-300"
    >
      Lost
    </span>
  );
}

export default function UserHistory({ history }) {
  if (!history?.length)
    return (
      <div className="bg-slate-800 rounded-xl p-4">
        <div className="text-gray-400 text-center">No lottery history yet.</div>
      </div>
    );

  return (
    <div className="bg-slate-800 rounded-xl p-4">
      <div className="font-bold mb-2">My Lottery History</div>
      <ul className="space-y-2">
        {history.map((h, i) => (
          <li
            key={i}
            className={`flex justify-between items-start gap-4 rounded-xl px-3 py-2
                        ${
                          !h.resolved
                            ? "bg-slate-800/60 ring-1 ring-amber-400/20"
                            : ""
                        }`}
          >
            <div className="min-w-0">
              <div className="font-medium truncate">
                Card #{h.cardId}
                {typeof h.winningNumber === "number" && h.resolved && (
                  <span className="ml-2 text-xs text-slate-400 align-middle">
                    win#: {h.winningNumber}
                  </span>
                )}
              </div>

              {/* pretty numbers */}
              <NumberChips h={h} />
            </div>

            <ResultPill h={h} />
          </li>
        ))}
      </ul>
    </div>
  );
}
